export class CrdtAlgorithmNotAvailable {
    id = 'NotAvailable';
    algoType = 'NotAvailable';
}
export function isNotAvailableCrdtAlgorithm(algo) {
    return algo.algoType === 'NotAvailable';
}
//# sourceMappingURL=CrdtAlgorithmNotAvailable.js.map